<template>
    <button v-if="shouldShow" class="db-card-filter-btn table-filter-btn">
        <i class="lab lab-line-filter lab-font-size-14"></i>
        <span>{{ $t('button.filter') }}</span>
    </button>
</template>

<script>
export default {
    name: "FilterComponent",
    props: {
        page: {
            type: Object,
            default: null,
        },
        search: {
            type: Object,
            default: null,
        },
    },
    computed: {
        resolvedPage() {
            const pageCandidates = [
                this.page,
                this.$parent?.paginationPage,
                this.$parent?.page,
                this.$parent?.pagination,
            ];

            return pageCandidates.find((candidate) => {
                return candidate && typeof candidate === "object" && Object.prototype.hasOwnProperty.call(candidate, "total");
            }) || null;
        },
        resolvedSearch() {
            return this.search || this.$parent?.props?.search || this.$parent?.search || null;
        },
        shouldShow() {
            const total = Number(this.resolvedPage?.total ?? 0);
            const perPage = Number(this.resolvedSearch?.per_page ?? this.resolvedPage?.per_page ?? 10);
            const min = 0;
            return true;
            // return total > min;
        },
    }
}
</script>
